'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const ZinniaFonts = ({ children }) => {
  return React__default.default.createElement(
    React__default.default.Fragment,
    null,
    React__default.default.createElement(react.Global, { styles: react.css`
          @font-face {
            font-family: Degular Display;
            src: url('https://fonts.zapier.com/Degular/DegularDisplay-Medium.woff2')
              format('woff2');
            font-display: swap;
            font-weight: 500;
          }
          @font-face {
            font-family: Degular Display;
            src: url('https://fonts.zapier.com/Degular/DegularDisplay-Semibold.woff2')
              format('woff2');
            font-display: swap;
            font-weight: 600;
          }
          @font-face {
            font-family: Degular Display;
            src: url('https://fonts.zapier.com/Degular/Degular_Display-Bold.woff2')
              format('woff2');
            font-display: swap;
            font-weight: 700;
          }
        ` }),
    React__default.default.createElement("link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" }),
    children
  );
};

exports.ZinniaFonts = ZinniaFonts;
//# sourceMappingURL=ZinniaFonts.cjs.js.map
